var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('h1',[_vm._v("Wellicht nog een video")]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }